module.exports = __webpack_public_path__ + "static/media/yingxiao.9daaea67.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/yingxiao.png
// module id = 2181
// module chunks = 0